module.exports = __webpack_public_path__ + "static/img/gaozhonghuaxue6.d4c3554b.jpg";